import customerReportNoStrain from './customerReportNoStrain'
export default customerReportNoStrain
